import moment from "moment";

export const calculateNextDesignatedDate = (dayOf: number) => {
  const currentDate = moment.utc();
  const nextMonth = currentDate.clone().add(1, "months");
  return nextMonth.date(dayOf).format("YYYY-MM-DD");
};
